import { useRouter } from 'vue-router'
import { useMarkNotificationRead } from '@/features/notifications/mutations/useMarkNotificationRead'
import type { Notification } from '@/features/notifications/types/notification'

/**
 * Marks a notification read and opens its route, if it has one. A route name this app no longer
 * has (renamed since the notification was stored) is ignored rather than throwing.
 */
export function useOpenNotification() {
  const router = useRouter()
  const markRead = useMarkNotificationRead()

  return function openNotification(notification: Notification): void {
    if (notification.readAt === null) markRead.mutate(notification.id)

    const route = notification.route
    if (!route || !router.hasRoute(route.name)) return

    router.push({ name: route.name, params: route.params, query: route.query })
  }
}
